export default __webpack_public_path__ + "assets/models/6d115788184153264c18598221c1be1e.glb";